import React from 'react';
import clsx from 'clsx';
import { useListCellStyles } from './style';


type ListCellProps = {
    className?: string,
    children?: React.ReactNode,
    width?: string | number,
    align?: 'right' | 'center' | 'left',
};

ListCell.defaultProps = {
    width: undefined,
    className: '',
    align: 'left',
    children: null,
};

const AlignToJustifyContent: { [key: string]: string } = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end',
};

function ListCell(props: ListCellProps): React.ReactElement {
    const { children, className, width, align = ListCell.defaultProps.align } = props;
    const classes = useListCellStyles();
    const style = width === undefined ? {} : { width, minWidth: width };
    const justifyContent = AlignToJustifyContent[align];

    return (
        <div className={clsx(classes.cell, className, 'cell')} style={{ ...style, justifyContent }}>
            {children}
        </div>
    );
}

export { ListCell };
